import Util        from '@/util';
import { userKey } from '@/global';
import Vue         from 'vue';
import Router      from 'vue-router';
import paths       from './paths';
import NProgress   from 'nprogress';
import 'nprogress/nprogress.css';

Vue.use(Router);
const router =  new Router({
    base            : '/',
    mode            : 'hash',
    linkActiveClass : 'active',
    routes          : paths
});
// router gards
router.beforeEach((to, from, next) => {
    NProgress.start();
    const user = JSON.parse(localStorage.getItem(userKey));

    if (to.matched.some(record => "permissions" in record.meta)) {
        if (user && to.matched.some(record => Util.hasIn(record.meta.permissions, user.perfis))) {
            next();
        } else {
            next({ path : '/403' });
        }
    } else {
        next();
    }
});

router.afterEach((to, from) => {
    NProgress.done();
});

export default router;
